import { useEffect } from "react";

export const useKeyboardKeydown = ({
  letter = "f",
  action,
  ignore_meta_ctrl_key = false,
}: {
  letter?: string;
  action: (e: KeyboardEvent) => void;
  ignore_meta_ctrl_key?: boolean;
}) => {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (
        (e.ctrlKey || e.metaKey || ignore_meta_ctrl_key) &&
        e.key === letter
      ) {
        action(e);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [action, letter, ignore_meta_ctrl_key]);
};
